<template>
  <div>
    <Head title="Applicant Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/volunteers">{{$t('volunteers.volunteers')}}</Link>
      <span class="text-gray-400 font-medium">/ </span> {{$t('volunteers.new')}}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <Form :form-data="form" :languages="languages"></Form>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{$t('global.create')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
  },
  props: {
    languages: Array,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        date_birth: '',
        date_entry: '',
        date_exit: '',
        career: '',
        hobbies: '',
        phone: '',
        email: '',
        street: '',
        street_number: '',
        zip_code: '',
        city: '',
        authorization_date: '',
        visitor: 0,
        max_treatments: 0,
        status: 1,
        language_ids: [],
        language_field: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/volunteers')
    },
  },
}
</script>
